<template>
	<div id="reset-scene-modal" class="modal-new hidden">
		<svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
			<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
		<span class="title">Reset</span>
		<p class="description">Are you sure you want to reset everything?</p>
		<div class="buttons-continer">
			<button type="button" class="modal-btn --primary" data-modal-action="reset-scene">Reset</button>
			<button type="button" class="modal-btn --cancel" data-modal-action="close-modal">Cancel</button>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style></style>
